export const mountOfferPhone = (): void => {
  const onClick = (ev: Event) => {
    const target = ev.target as HTMLElement | null;
    if (!target) return;
    const btn = target.closest('.js-toggle-phone') as HTMLButtonElement | null;
    if (!btn) return;

    const container = btn.parentElement as HTMLElement | null;
    if (!container) return;

    const display = container.querySelector<HTMLElement>('.js-phone-display');
    if (!display) return;

    const showLabel = btn.getAttribute('data-show-label') || 'Pokaż numer';
    const hideLabel = btn.getAttribute('data-hide-label') || 'Ukryj numer';
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      const mask = display.getAttribute('data-mask') || '--- --- ---';
      display.textContent = mask;
      btn.textContent = showLabel;
      btn.setAttribute('aria-expanded', 'false');
    } else {
      const phone = display.getAttribute('data-phone');
      if (!phone) return;
      display.textContent = phone;
      btn.textContent = hideLabel;
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  document.addEventListener('click', onClick);
};

